import React from 'react';
import { List as AntList, ListProps as AntListProps } from '@vertem-core/vertice-ds';

const List: React.FC<AntListProps<any>> & { Item: typeof AntList.Item } = (props) => <AntList {...props} />;

List.Item = AntList.Item;

export default List;
